import React, { useEffect, useState } from 'react';
import "./StepSummary.scss";
import { getIdFromLocalStorage, getJsonFromLocalStorage } from "../../../utils";
import { getPayment } from '../../../api/deudas';
import { Button, Message, Container } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import infoIcon from '../../../assets/svg/info.svg';
import { formatCurrency, dateType } from '../../../utils/stringsAndFormats';
import { Icon } from "../../../assets";
import { ENV } from "../../../utils";


function StepSummary() {

  const [paymentData, setPaymentData] = useState(null);

  const id = getIdFromLocalStorage();
  const debt = getJsonFromLocalStorage();

  const navigate = useNavigate();

  const handlePrint = () => {
    window.print();
  };

  const handleRedirectToHome = () => {
    window.location.href = ENV.BASE_BOX;
  };

  const handleRefresh = () => {
    navigate('/resumen');
  };

  useEffect(() => {

    if (id === null || debt === null) {navigate('/');}

    const fetchPaymentData = async () => {
      try {
        const payload = {
          transaccion: {
            codigo: id,
          },
        };

        const data = await getPayment(payload);
        setPaymentData(data);

      } catch (err) {
        console.error(err);
      }
    };

    fetchPaymentData();
  }, [id]);

  return (
    paymentData && paymentData.pago && paymentData.pago.estado === 'APROBADO' ? (
      <>
        <Container className="step-container">

          <div className="step-icons">
            <div className="step-icon active"></div>
            <div className="step-icon active"></div>
            <div className="step-icon active"></div>
            <div className="step-icon active"></div>
          </div>

          <div className="steps-container">
            <div className="steps-title"><strong>Paso 4 de 4:</strong> Comprobante del pago</div>

            <p className="steps-text-big-out mt-1">¡Pago realizado!</p>
          <p className="steps-text-out">A continuación, encuentras el detalle del pago. Te recomendamos imprimir el comprobante.</p>

            <div className="steps-card-box">
              <div className="steps-card-content">
                <div className="steps-card" id="pago_realizado">
                  <p className="steps-text-big">¡Pago realizado!</p>
                  <p className="steps-text">A continuación, encuentras el detalle del pago. Te recomendamos imprimir el comprobante.</p>

                  <div>
                    <div className="summary-flex">
                      <div className="summary-left">Producto pagado:</div>
                      <div className="summary-middle"><hr className="dotted-separator"/></div>
                      <div className="summary-right">{debt.descriptionValue}</div>
                    </div>
                    <div className="summary-flex">
                      <div className="summary-left">Número de producto:</div>
                      <div className="summary-middle"><hr className="dotted-separator"/></div>
                      <div className="summary-right">{debt.billNumber}</div>
                    </div>
                    <div className="summary-flex">
                      <div className="summary-left">{dateType(debt.type)}:</div>
                      <div className="summary-middle"><hr className="dotted-separator"/></div>
                      <div className="summary-right">{debt.description2}</div>
                    </div>
                    <div className="summary-flex">
                      <div className="summary-left">Monto pagado:</div>
                      <div className="summary-middle"><hr className="dotted-separator"/></div>
                      <div className="summary-right">{formatCurrency(paymentData.total.valor)}</div>
                    </div>

                    <Message icon id='wp'  style={{ marginTop: '1rem' }}>
                      <img src={infoIcon} alt="icono" />
                      <Message.Content>
                        { ENV.TEXT.MSG_PAYMENT_TIME }
                      </Message.Content>
                    </Message>

                  </div>

                </div>
              </div>
            </div>

            <div className="grid-container-button">
              <div className="botonera-izq min-center">
                <Button id="finalizar" type="submit" onClick={handleRedirectToHome} className="boton-izquierdo">
                  Finalizar
                </Button>
              </div>
              <div className="botonera-der">
                <Button  
                  id="imprimir_comprobante"
                  onClick={handlePrint}
                  onMouseUp={(e) => e.currentTarget.blur()} 
                  onBlur={(e) => e.currentTarget.blur()}>
                  Imprimir comprobante
                </Button>
              </div>
            </div>

          </div>
        </Container>
      </>
    ) : paymentData && paymentData.pago ? (
      <Container className="step-container">

      <div className="steps-container">
        <div className="steps-card-box mt-12">
          <div className="steps-card-content center">

              {paymentData.pago.estado === 'PENDIENTE' ? <Icon.Pending /> : <Icon.Rejected />}

              <p className="summary-title">
              {paymentData.pago.estado === 'RECHAZADO' ? 'Pago rechazado' : paymentData.pago.estado === 'CANCELADO' ? 'Pago cancelado' : 'Transacción pendiente'}</p>
              
              <p className="summary-text">  {
              paymentData.pago.estado === 'RECHAZADO' ? ENV.TEXT.MSG_PAYMENT_REJECTED : paymentData.pago.estado === 'CANCELADO' ? 
              ENV.TEXT.MSG_PAYMENT_CANCELED : ENV.TEXT.MSG_PAYMENT_PENDING }</p>

              <Button type="submit"  onClick={handleRefresh}>
                Volver a intentar
              </Button>
           
          </div>
        </div>

        <div className="grid-container-button"  style={{ paddingTop: '32px' }}>
        
        </div>

      </div>
    </Container>
    ) : (
      <div></div>
    )
  );
}

export default StepSummary;
